module.exports = __webpack_public_path__ + "img/P0-zh.8db2784f.png";